module.exports = __webpack_public_path__ + "img/singletrack-study.14f7b23a.png";